import React from "react";
import ApplicationRoutes from "./routes/routes";

const App = () => {
    return (
        <ApplicationRoutes/>
    );
}

export default App;
